import { createAsyncThunk } from '@reduxjs/toolkit';

import type { AppThunkConfig } from '@/types/Store';

/**
 * Typed async thunk creator
 * Provides type safety for state and services in thunks
 */
export const createAppAsyncThunk: ReturnType<typeof createAsyncThunk.withTypes<AppThunkConfig>> =
  createAsyncThunk.withTypes<AppThunkConfig>();
